interface FlyoutLeftProps {
    open: boolean;
    children: React.ReactElement;
}

export default ({ open, children }: FlyoutLeftProps) => <aside className={`overflow-hidden bg-white shadow-sm transition-all duration-300 sticky top-64 ${open ? 'w-72' : 'w-14'}`}>{children}</aside>;
